import * as React from "react";
import {
  Size,
  Col,
  Paragraph,
  Text,
  TextColor,
  ActionList,
  TextAlignment,
  LinkActionItem,
  Icon,
  IconName,
  IconSize,
  MediaObject,
  Space,
  Grid,
  RowCol,
  GridSpacing,
  UserInitialsAvatar,
  Pill,
  Avatar,
} from "@root/shared";
import { observer, inject } from "mobx-react";
import { GitHubAppUIStore } from "./github-app-ui-store";
import { Helmet } from "react-helmet";
import { logger } from "@root/lib/telemetry";
const styles = require("./repository-list.scss");

@inject("githubAppUIStore")
@observer
export class RepositoryList extends React.Component<{ githubAppUIStore: GitHubAppUIStore }> {
  public trackClickFaq = (source: string) => {
    logger.info("FAQ link clicked", { scenario: "github-integration", faq_source: source });
  };

  public trackSelectRepo = (index: number) => {
    logger.info("Repo selected", { scenario: "github-integration", index: index });
  };

  public render() {
    const { isLoading, filteredData, ownerAvatarURL, ownerName, query } = this.props.githubAppUIStore;
    return (
      <>
        <Helmet title="Select repository" />
        {isLoading ? null : (
          <Grid rowSpacing={GridSpacing.XSmall}>
            {!!filteredData.length && (
              <RowCol>
                <MediaObject hSpace={Space.XSmall}>
                  {ownerAvatarURL ? (
                    <Avatar src={ownerAvatarURL} size={30} alt={`@${ownerName || ownerAvatarURL}`} />
                  ) : ownerName ? (
                    <UserInitialsAvatar initialsName={ownerName} size={30} />
                  ) : (
                    <Avatar alt={"default avatar"} />
                  )}
                  <Paragraph size={Size.Medium} bold>
                    @{ownerName}
                  </Paragraph>
                </MediaObject>
              </RowCol>
            )}
            <RowCol>
              {!!filteredData.length ? (
                <Grid rowSpacing={GridSpacing.Small}>
                  <RowCol>
                    <ActionList data-test-id="repository-list">
                      {filteredData.map(({ id, name, shortDescription, relativeDate, language, fork, private: isPrivate }, index) => (
                        <LinkActionItem
                          to={`/github-app/setup/repositories/${id}${window.location.search}`}
                          key={id}
                          noChevron
                          onClick={() => this.trackSelectRepo(index)}
                        >
                          <Col>
                            <Paragraph size={Size.Medium} bold className={styles.title}>
                              <Icon
                                className={styles.icon}
                                color={TextColor.Secondary}
                                icon={isPrivate ? IconName.LockAlt : fork ? IconName.Fork : IconName.Repository}
                                alt={isPrivate ? "Private" : fork ? "Fork" : ""}
                                size={IconSize.XXSmall}
                              />
                              {name}
                              {language ? <Pill className={styles.language}>{language}</Pill> : null}
                            </Paragraph>
                            <Paragraph size={Size.Medium} color={TextColor.Secondary}>
                              {shortDescription}
                            </Paragraph>
                          </Col>
                          <Col className={styles.timestampColumn}>
                            <Paragraph
                              align={TextAlignment.Right}
                              size={Size.Small}
                              color={TextColor.Secondary}
                              className={styles.updateLabel}
                            >
                              Updated
                            </Paragraph>
                            <Paragraph align={TextAlignment.Right} size={Size.Medium}>
                              {relativeDate}
                            </Paragraph>
                          </Col>
                        </LinkActionItem>
                      ))}
                    </ActionList>
                  </RowCol>
                  <RowCol>
                    <Paragraph color={TextColor.Secondary} size={Size.Medium}>
                      Can’t find a repository? Make sure you have the right permissions.{" "}
                      <a target="_blank" href="https://aka.ms/github-integration" onClick={() => this.trackClickFaq("has-repo")}>
                        Read more.
                      </a>
                    </Paragraph>
                  </RowCol>
                </Grid>
              ) : (
                <Grid>
                  <RowCol>
                    <Paragraph color={TextColor.Secondary} size={Size.Medium}>
                      No repositories found matching{" "}
                      <Text bold size={Size.Medium}>
                        “{query}”
                      </Text>
                    </Paragraph>
                  </RowCol>
                  <RowCol>
                    <Paragraph color={TextColor.Secondary} size={Size.Medium}>
                      Make sure you have the right permissions.{" "}
                      <a target="_blank" href="https://aka.ms/github-integration" onClick={() => this.trackClickFaq("no-repo")}>
                        Read more.
                      </a>
                    </Paragraph>
                  </RowCol>
                </Grid>
              )}
            </RowCol>
          </Grid>
        )}
      </>
    );
  }
}
